<div *ngIf="data.length > 0" class="info-dashboard-card-container">
  <div *ngFor="let item of data" class="container-info-card" [nz-tooltip]="formatNumber(item.value)" nzMd="5" nzSm="12" nzXs="24">
    <p class="title">
      {{item.title}}
    </p>
    <h3 class="value">{{(item.value | shortCurrency).amount}} {{(item.value | shortCurrency).suffix}}<span *ngIf="item.currency != undefined || item.currency != null">{{item.currency}}</span></h3>
  </div>
</div>
